import { render, staticRenderFns } from "./m-dialog-youtube.vue?vue&type=template&id=3351ff22&lang=pug&"
import script from "./m-dialog-youtube.vue?vue&type=script&lang=js&"
export * from "./m-dialog-youtube.vue?vue&type=script&lang=js&"
import style0 from "./m-dialog-youtube.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports